module.exports = __webpack_public_path__ + "img/blank-page.4246f1c2.svg";